import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { GreenroomState } from '../stores/types/types';
import { FkTable } from '../stores/types/content';

export const DOP_PROVIDER = 'digitalofficepro';

interface DopPresentation {
	isDop: boolean;
	contentUrl: string | undefined;
}

/**
 * Resolves the DigitalOfficePro (DOP) presentation for a media item.
 *
 * A DOP-converted PPTX is a `gr_generated_content` row whose
 * `provider === 'digitalofficepro'`, keyed to the media item via
 * `fkTable === 'gr_media'` && `fkId === mediaId`. The viewer URL lives in
 * `contentUrl`. When present, the media renders as an iframe pointed at that URL
 * rather than as an image/video from `media_data.image_array`.
 */
const useDopPresentation = (mediaId: number): DopPresentation => {
	const generatedContent = useSelector(
		(s: GreenroomState) => s.GeneratedContentReducer.generatedContent,
	);

	return useMemo(() => {
		const row = generatedContent?.find(
			// eslint-disable-next-line eqeqeq
			(x) => x.fkTable === FkTable.media
				&& x.fkId == mediaId // loose: fkId can arrive as a string (matches use-media-memos)
				&& x.provider === DOP_PROVIDER,
		);
		return {
			isDop: !!row?.contentUrl,
			contentUrl: row?.contentUrl,
		};
	}, [generatedContent, mediaId]);
};

export default useDopPresentation;
